import { Error } from "sharedb";
import { Callback, Doc, Op, ShareDBSourceOptions } from "sharedb/lib/client";

import { WorksheetType } from "../../shared/types/worksheet";

export const getFakeDoc = (data: WorksheetType) => {
  const fakeDoc = {
    submitOp: (op: Op | Op[], options: ShareDBSourceOptions, callback: Callback) => {
      console.info("fake-doc submitOp: not applying op:", op);
      if (callback) {
        callback(null as unknown as Error);
      }
    },
    data,
    id: "fake-doc",
    on: () => {},
    presence: { create: () => {}, on: () => {}, off: () => {} },
    removeListener: () => {},
  } as unknown as Doc<WorksheetType>;

  return fakeDoc;
};
